import website from '../assets/website.png'
import email from '../assets/email.png'
import youtube from '../assets/youtube.png'
import github from '../assets/github.png'
import telegram from '../assets/telegram.png'
import twitter from '../assets/twitter.png'
import discord from '../assets/discord.png'


const items = [
{
    "title": "Help Portal",
    "subtitle": "Advice and answers from Pillar support team!",
    "image": website,
    "link": "https://docs.pillar.fi/"
},
{
    "title": "Blog",
    "subtitle": "Read community,partnerships, product and smart wallet blog posts!",
    "image": website,
    "link": "https://medium.com/pillarproject"
},
{
    "title": "GitHub",
    "subtitle": "Look at OpenSource magic :)",
    "image": github,
    "link": "https://github.com/pillarwallet" //Github Profile link
},
{
    "title": "Twitter",
    "subtitle": "Let's connect on twitter!",
    "image": twitter,
    "link": "https://x.com/PX_Web3"// twitter profile link 
},
{
    "title": "Discord",
    "subtitle": "Let's chat about Pillar!",
    "image": discord    ,
    "link": "https://chat.pillar.fi" 
},
{
    "title": "YouTube",
    "subtitle": "We make videos!",
    "image": youtube,
    "link": "https://www.youtube.com/c/PillarProject"//youtube channel link 
},
{
    "title": "Telegram",
    "subtitle": "Another communication platform?! Ok",
    "image": telegram,
    "link": "https://t.me/pillarxweb3" //Telegram Pofile 
},
{
    "title": "Mail",
    "subtitle": "Old way?! Let's e-mail!",
    "image": email,
    "link": "mailto:support@pillarproject.io" //Mail address
}]

export default items
